import { css } from 'styled-components';

import { ColorType, TButtonType } from '@r1-frontend/ui-kit/atoms/button';
import { ColorsInterface } from '@r1-frontend/ui-kit/themes/colors/types';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

type TColors = {
    background: {
        base: ColorType,
        active: ColorType,
        hover: ColorType,
    },
    textColor: ColorType,
}

const getColorsByType = ($type: TButtonType, colors: ColorsInterface): TColors => {
    switch ($type) {
        // @todo заменить на токены цветов
        case 'accent':
            return {
                background: {
                    base: colors.system.accent,
                    active: '#bf2521',
                    hover: '#d92a25',
                },
                textColor: colors.text.contrast,
            };
        case 'primary':
            return {
                background: {
                    base: colors.system.primary,
                    active: '#404152',
                    hover: '#343547',
                },
                textColor: colors.text.contrast,
            };
        case 'secondary':
            return {
                background: {
                    base: colors.system.secondary,
                    active: '#99c0d3',
                    hover: '#b3d9ec',
                },
                textColor: colors.text.head,
            };
        case 'outline':
        case 'ghost':
            return {
                background: {
                    base: 'transparent',
                    active: 'transparent',
                    hover: 'transparent',
                },
                textColor: colors.links.accent,
            };
    }
};

const getColors = () => ({ theme, $type = 'accent' }: ThemedProperties<{ $type?: TButtonType }>) => {
    const colors = getColorsByType($type, theme.colors);

    return css`
        background-color: ${colors.background.base};
        color: ${colors.textColor};

        &:active {
            background-color: ${colors.background.active};           
        }

        @media (hover: hover) {
            &:hover {
                background-color: ${colors.background.hover};
            }
        }
    `;
};

export default getColors;
